import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TaskApi from '@/api/task'
import LawsuitApi from '@/api/lawsuit'

let id: any = 0
import BillApi from '@/api/bill'
import VisitorApi from '@/api/visitor'
import { idCard } from '@/utils/validator'
import Moment from 'moment'
import { nameLength } from '@/config/global'
import AreaApi from '@/api/area'
import { debounce, hasValue } from '@/utils/util'
import { caseNoReg, contactPhonePattern } from '@/utils/regExp'
import moment from 'moment'
import { YI_WAN_CHENG } from '@/web-task/config'

const debounceSearch = debounce(300)
const needInputType: any = ['02', '03', '04', '10', '17']
const injuryType: any = ['01', '02', '03', '04', '05', '06']

@Component({})
export default class AddTaskMixin extends Vue {
	public addForm: any = {}
	public addLoading: boolean = false
	public phoneId: number = 0
	public hasNoCarNo: boolean = false
	public isInjured: boolean = false
	public searchArea: any = []
	public courtList: any = []
	public noData: boolean = false
	public searchHospital: any = []
	public localSearch: any = ''
	public fetching: boolean = false
	public sameWithPublisher: boolean = false
	public areaName: string = ''
	public resurvey: boolean = false
	public endOpen: boolean = false
	public isPatient: any = true
	public taskType: any = ''
	public picId: any = ''
	public fileList: any = []
	public nameLength: any = nameLength
	public max: number = 99999999.99
	public min: number = 0.0
	public includeFormType: any = ''
	public YING_SU: any = '01'
	public SHANG_SU: any = '02'
	public mediaInfo: any = false
	public hasScheme: any = false
	public caseNoReg: any = caseNoReg
	public contactPhonePattern: any = contactPhonePattern

	@Prop()
	public data!: any

	public handleRemove() {
		this.fileList = []
	}

	public async checkRelated() {
		const orderNo = this.addForm.getFieldValue('orderNo')
		this.addForm.setFields({
			orderNo: {
				value: orderNo,
				errors: null,
			},
		})
		if (!orderNo) {
			return
		}
		let errMsg = ''
		try {
			const res = await LawsuitApi.queryRelated(orderNo)
			if (res && res.data) {
				if (res.data.orderStatus !== YI_WAN_CHENG) {
					errMsg = '该案件在系统中还未完结'
				} else {
					this.setFormData(res.data)
				}
			} else {
				errMsg = '请输入正确的关联订单号'
			}
		} catch (err) {
			console.log('checkRelated error: ', err)
			errMsg = '请输入正确的关联订单号'
		}
		if (errMsg) {
			this.addForm.setFields({
				orderNo: {
					value: orderNo,
					errors: [new Error(errMsg)],
				},
			})
		}
	}

	public setPublisher() {
		this.$nextTick(() => {
			if (this.sameWithPublisher) {
				this.addForm.setFieldsValue({
					contact: this.$store.state.user.userInfo.name,
					contactPhone: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.addForm.setFieldsValue({
					contact: undefined,
					contactPhone: undefined,
				})
			}
		})
	}

	// 是否正确的关联订单
	public async isRightRelated(rule: any, value: any, callback: Function) {
		const res = await LawsuitApi.queryRelated(value)
		if (res && res.data) {
			this.setFormData(res.data)
			callback()
		} else {
			callback(new Error('找不到该一审订单'))
		}
	}

	public setFormData(data: any) {
		console.log(data)
		// this.hasScheme = data.hasScheme
		const arr = [
			'agentType',
			'carProperty',
			'caseNo',
			'contact',
			'contactPhone',
			'courtAmount',
			'death',
			'includeFormType',
			'lawsuitType',
			'plaintiff',
			'readPaper',
			'orderNo',
		]
		const obj: any = {}
		for (const item of arr) {
			if (data[item]) {
				obj[item] = data[item]
			}
		}
		if (
			data.provinceCode &&
			data.cityCode &&
			data.countryCode &&
			data.fullDesc
		) {
			obj.code = {
				label: data.fullDesc,
				key: `${data.provinceCode}-${data.cityCode}-${data.countryCode}`,
			}
		}
		this.$emit('setData', 'includeFormType', data.includeFormType)
		this.$emit('setData', 'death', data.death)
		this.includeFormType = data.includeFormType
		this.addForm.setFieldsValue(obj)
		// data.formDetailList = [{
		// 	insuranceFormType: '',
		// 	insuranceFormTypeDesc: '哈哈',
		// }, {
		// 	insuranceFormType: '02',
		// 	insuranceFormCoverage: '123',
		// }, {
		// 	insuranceFormType: '01',
		// }]
		for (const item of data.formDetailList) {
			if (item.insuranceFormType === '') {
				obj.formDetailOther = item.insuranceFormTypeDesc
			} else if (item.insuranceFormType) {
				if (hasValue(item.insuranceFormCoverage)) {
					if (!obj.formDetailList) {
						obj.formDetailList = {}
					}
					obj.formDetailList[item.insuranceFormType] = {
						checked: true,
						amount: item.insuranceFormCoverage,
					}
				} else {
					if (!obj.formDetail) {
						obj.formDetail = []
					}
					obj.formDetail.push(item.insuranceFormType)
				}
			}
		}
		this.mediaInfo = data.mediaInfo
		this.$nextTick(() => {
			this.addForm.setFieldsValue(obj)
		})
	}

	public onWithPublisherChange(e: any) {
		this.sameWithPublisher = e.target.checked
		this.setPublisher()
	}

	public areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(value).then((res: any) => {
					if (res.data.length) {
						this.noData = false
						this.searchArea = res.data.map((item: any) => {
							return {
								code: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								area: item.provName + '-' + item.cityName + '-' + item.areaName,
								cityName: item.cityName,
							}
						})
					} else {
						this.noData = true
						this.searchArea = []
					}
					resolve()
				})
			})
		})
	}

	public courtSearch(searchKey: string | undefined) {
		debounceSearch(() => {
			if (!searchKey) {
				return
			}
			let fullDesc = (this.addForm.getFieldValue('code') || {}).label
			let descArr = (fullDesc || '').trim().split('-')
			LawsuitApi.getCourt({
				arg: searchKey,
				prov: descArr && (descArr[0] || '').replace(/[省市]/, ''),
				city: descArr && (descArr[1] || '').replace('市', ''),
			})
				.then(res => {
					this.courtList = [...new Set(res.data || [])].map((item: any) => {
						return {
							value: item,
							label: item,
						}
					})
					if (!(this.courtList && this.courtList.length)) {
						this.addForm.setFieldsValue({
							courtName: searchKey,
						})
					}
				})
				.catch(err => {
					this.addForm.setFieldsValue({
						courtName: searchKey,
					})
				})
		})
	}

	public handleEndOpenChange(open: boolean) {
		this.endOpen = open
	}

	public disabledStartDate(startValue: any) {
		return startValue.valueOf() < Moment().startOf('day')
	}

	public handleStartOpenChange(open: boolean) {
		if (!open) {
			this.endOpen = true
		}
	}

	public onPatientInput() {
		if (this.isPatient) {
			this.addForm.setFieldsValue({
				certigier: this.addForm.getFieldValue('injuredName'),
				certigierPhone: this.addForm.getFieldValue('injuredPhone'),
			})
		}
	}

	public onIsPatient() {
		this.isPatient = !this.isPatient
		if (this.isPatient) {
			this.addForm.setFieldsValue({
				certigier: this.addForm.getFieldValue('injuredName'),
				certigierPhone: this.addForm.getFieldValue('injuredPhone'),
			})
		}
	}

	public checkIdNo(rule: string, value: string, cb: any) {
		const idNo = value

		if (!idNo) {
			cb(new Error('请输入就诊人身份证号码'))
		} else if (!idCard(idNo)) {
			cb(new Error('请输入正确的身份证号码'))
		} else {
			cb()
		}
	}

	public get showInjury() {
		return ['01', '03'].includes(this.includeFormType)
	}

	public get showCar() {
		return ['02', '03'].includes(this.includeFormType)
	}

	public onDeathSelect(val: string) {
		this.$emit('setData', 'death', val)
	}

	public setPlan() {
		this.$emit('setPlan')
	}

	public setScheme() {
		if (this.data.scheme) {
			this.hasScheme = '1'
		} else {
			this.hasScheme = '0'
		}
	}

	public activated() {
		this.setScheme()
	}

	public created() {
		this.addForm = this.$form.createForm(this)
		this.sameWithPublisher = true
		this.setPublisher()
		this.setScheme()
	}

	public onFormTypeChange(val: any) {
		this.includeFormType = val
		this.$emit('setData', 'includeFormType', val)
		this.addForm.resetFields([
			'formDetail',
			'formDetailList',
			'formDetailOther',
		])
	}

	public get insuranceFormList() {
		const list = this.$store.state.setting.insuranceFornTypeList
			.filter((item: any) => !needInputType.includes(item.key))
			.map((item: any) => {
				return {
					label: item.value,
					value: item.key,
				}
			})
		if (this.showInjury && !this.showCar) {
			return list.filter((item: any) => {
				return injuryType.includes(item.value)
			})
		} else if (!this.showInjury && this.showCar) {
			return list.filter((item: any) => {
				return !injuryType.includes(item.value)
			})
		}
		return list
	}

	public onOk(orderId: any) {
		this.$multiTab.closeCurrentPage()
		this.$multiTab.open(`/lawsuit/taskDetail/${orderId}`)
	}

	public formDetailCheck(rule: any, value: string, cb: any) {
		const field = rule.field
		const arr = field.split('.')
		arr.pop()
		const str = arr.join('.')
		const item = this.addForm.getFieldValue(str)

		if (item.checked && !value) {
			cb(new Error('请输入保单金额'))
		} else {
			cb()
		}
	}

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields(async (err: any, values: any) => {
			console.log(values)
			if (!err) {
				values = cloneDeep(values)

				// 需要输入金额的项
				const formDetailListHasCheck = needInputType.some((item: any) => {
					return (
						values.formDetailList[item] && values.formDetailList[item].checked
					)
				})
				if (
					(!values.formDetail || values.formDetail.length === 0) &&
					!values.formDetailOther &&
					!formDetailListHasCheck
				) {
					return this.$message.error('请选择案件涉诉保单')
				}
				const uploadData: any = this.$refs.uploadData
				await uploadData.validate()
				values.mediaInfo = uploadData.getList()
				const formDetailList = []
				if (values.formDetail && values.formDetail.length) {
					for (const item of values.formDetail) {
						formDetailList.push({
							insuranceFormType: item,
							insuranceFormTypeDesc: this.$store.state.setting
								.insuranceFornTypeMap[item],
						})
					}
					delete values.formDetail
				}
				if (formDetailListHasCheck) {
					for (const item of needInputType) {
						if (
							values.formDetailList[item] &&
							values.formDetailList[item].checked
						) {
							formDetailList.push({
								insuranceFormType: item,
								insuranceFormTypeDesc: this.$store.state.setting
									.insuranceFornTypeMap[item],
								insuranceFormCoverage: values.formDetailList[item].amount,
							})
						}
					}
					delete values.formDetailList
				}
				if (values.formDetailOther) {
					formDetailList.push({
						insuranceFormType: '',
						insuranceFormTypeDesc: values.formDetailOther,
					})
					delete values.formDetailOther
				}

				this.addLoading = true
				if (values.orderNo) {
					const orderNo = values.orderNo
					try {
						const res = await LawsuitApi.queryRelated(orderNo).finally(() => {
							this.addLoading = false
						})
						if (!res || !res.data) {
							return this.$message.error('请输入正确的关联订单号')
						}
						if (res && res.data && res.data.orderStatus !== YI_WAN_CHENG) {
							return this.$message.error('该案件在系统中还未完结')
						}
						await new Promise((resolve, reject) => {
							this.$confirm({
								title: '提示',
								content(h: any) {
									return h('div', {}, [
										h('span', '您的案件一审已派送对应律师-'),
										h(
											'span',
											{
												style: {
													color: '#0064DC',
													marginTop: '6px',
												},
											},
											res.data.lawyerName
										),
										h('span', '-代理，这次是否需要更换对应的律师？'),
									])
								},
								cancelText: '更换律师',
								okText: '不更换律师',
								onOk: () => {
									values.hasLawyer = '1'
									resolve()
								},
								onCancel: () => {
									resolve()
								},
							})
						})
					} catch (err) {
						console.log('checkRelated error: ', err)
						return this.$message.error('请输入正确的关联订单号')
					}
				}
				values.formDetailList = formDetailList
				values.fullDesc = values.code.label
				const codes = values.code.key.split('-')
				values.provinceCode = codes[0]
				values.cityCode = codes[1]
				values.countryCode = codes[2]
				delete values.code
				values.courtDate =
					values.courtDate && values.courtDate.format('YYYY-MM-DD HH:mm')
				if (values.lawsuitType) {
					values.taskType = values.lawsuitType === this.YING_SU ? '11' : '12' // 01应诉对应11二审应诉
				} else {
					values.taskType = this.taskType
				}
				values.hasScheme = this.hasScheme
				if (values.hasScheme === '1' && this.data.scheme) {
					values.scheme = this.data.scheme
				}

				this.addLoading = true
				LawsuitApi.addTask(values)
					.then((data: any) => {
						this.$message.success(data.message || '发布成功')
						this.onOk(data.data.id)
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}
}
